import { Footer } from "../../components/Footer";
import { IconsRow } from "../../components/IconsRow";
import { SlideScritta } from "../../components/MainSlide";
import { ApiScroller } from "../../components/Scroller";
import { TopDescription } from "../../components/TopDescription";
import { EventiAziende } from "./aziende";
import { EventiPrivati } from "./privati";
import { EventiSport } from "./sport";

export function Eventi() {
  return (
    <>
      <SlideScritta
        signUrl='/scrittavideo.webp'
        bgUrl='event/banner.webp'
        position='center'
      />
      <TopDescription reverse id='2oQBm2XoFj4jEbVLZUtbia' justifyContent meta />
      <EventiPrivati /> <EventiAziende />
      <EventiSport />
      <ApiScroller id='7MvUYwrfF5w5Q4boN42UNX' />
      <IconsRow />
      <Footer
        number='+390318180860'
        email='info@thepadelresort.it'
        prettyNumber='+39 031 8180 860'
      />
    </>
  );
}
